/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


require('mag-app')
    .log = function ( message ) {
        if ( require('../config').debug ) {
            console.log(message, ':player:');
        }
    };
